import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PATHS } from "../../../constants";
import "./styles.css";

const PageHeaderNav = ({ itemsNav }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        padding: "4px",
        borderRadius: "12px",
        gap: "8px",
        height: "48px",
        backgroundColor: "#ffffff",
        width: "fit-content",
        minWidth: "350px",
      }}
    >
      {itemsNav.map((item) => (
        <Box className={`pageNavHeader ${window.location.href.indexOf(item.text) > -1 ? "pageNavHeaderCureent" : ""}`}>
          <Typography onClick={() => navigate(PATHS[item.text.toUpperCase()])}>
            {t(`title_page:${item.text}`)}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default PageHeaderNav;
